import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationLearningProtectionContextModel extends OperationImportContextModel {
  learningDuration: number|null;
  countries: string[];
  orgUnitEndLearningId: string|null;
}
